/**
 * Generic filter search - works inside .js-tag-filter containers.
 * Filters .tag-filter-item elements by data-filter-search (e.g. name, title, tags).
 * Coordinates with tag-filter.js via tagFilter:searchChanged and data-hiddenBySearch.
 */
function initFilterSearch() {
	document.querySelectorAll(".js-tag-filter").forEach((container) => {
		const searchInput = container.querySelector(".js-filter-search");
		const clearBtn = container.querySelector(".js-filter-search-clear");
		const items = container.querySelectorAll(".tag-filter-item");

		if (!searchInput || !items.length) return;
		if (container.dataset.filterSearchInitialized === "true") return;
		container.dataset.filterSearchInitialized = "true";

		function getSearchText() {
			return (searchInput.value || "").trim().toLowerCase();
		}

		function applySearch() {
			const query = getSearchText();
			items.forEach((item) => {
				const searchable = (item.getAttribute("data-filter-search") || "").toLowerCase();
				// Items without data-filter-search are never hidden by search
				const hidden =
					query.length > 0 && searchable.length > 0 && !searchable.includes(query);
				item.dataset.hiddenBySearch = hidden ? "true" : "false";
			});
			container.dispatchEvent(
				new CustomEvent("tagFilter:searchChanged", { bubbles: true }),
			);
		}

		function updateClearButton() {
			if (clearBtn) {
				clearBtn.style.display = getSearchText() ? "inline-flex" : "none";
			}
		}

		searchInput.addEventListener("input", () => {
			applySearch();
			updateClearButton();
		});

		searchInput.addEventListener("keydown", (e) => {
			if (e.key === "Escape") {
				e.preventDefault();
				searchInput.value = "";
				applySearch();
				updateClearButton();
				searchInput.focus();
			}
		});

		if (clearBtn) {
			clearBtn.addEventListener("click", () => {
				searchInput.value = "";
				searchInput.focus();
				items.forEach((item) => {
					item.dataset.hiddenBySearch = "false";
				});
				container.dispatchEvent(
					new CustomEvent("tagFilter:searchChanged", { bubbles: true }),
				);
				updateClearButton();
			});
		}

		// Initial state
		updateClearButton();
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", () => {
		setTimeout(initFilterSearch, 50);
	});
} else {
	setTimeout(initFilterSearch, 50);
}
